import {
  Container,
  Typography,
  CardContent,
  Card,
  Box,
  CardActions,
} from "@mui/material";
import React from "react";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import VerifiedIcon from "@mui/icons-material/Verified";
import PlaceIcon from "@mui/icons-material/Place";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useTranslation } from "react-i18next";

export default function WhyUs() {
  const { t } = useTranslation();
  return (
    <Container
      id="features"
      sx={{
        marginBottom: "5%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      <Typography
        sx={{ color: "#1D2877", fontWeight: "bold", fontSize: "30px" }}
      >
        {t("Why Us ?")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: "70px",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          marginTop: "5%",
        }}
      >
        <Card
          sx={{
            width: "320px",
            height: "300px",
            borderRadius: "20px",
            backgroundImage: `linear-gradient(to right, #7ABAF3, #8FBADFA3)`,
          }}
        >
          <CardContent>
            <AdminPanelSettingsIcon
              sx={{
                marginLeft: "80%",
                color: "#1D2877",
                height: "60px",
                width: "20%",
              }}
            />
            <Typography
              gutterBottom
              sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
            >
              {t("Safety")}
            </Typography>
            <Typography color="#577ABE" sx={{ fontSize: "20px" }}>
              {t(
                "You may share your trip details with relatives and/or friends, in addition to strict safety measures."
              )}
            </Typography>
          </CardContent>
          <CardActions></CardActions>
        </Card>

        <Card
          sx={{
            width: "320px",
            height: "300px",
            borderRadius: "20px",
            backgroundImage: `linear-gradient(to right, #7ABAF3, #8FBADFA3)`,
          }}
        >
          <CardContent>
            <SentimentSatisfiedAltIcon
              sx={{
                marginLeft: "80%",
                color: "#1D2877",
                height: "60px",
                width: "20%",
              }}
            />
            <Typography
              gutterBottom
              sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
            >
              {t("Customer Support")}
            </Typography>
            <Typography color="#577ABE" sx={{ fontSize: "20px" }}>
              {t(
                "We answer your complaints about any inconveniencethrough your ride."
              )}
            </Typography>
          </CardContent>
          <CardActions></CardActions>
        </Card>

        <Card
          sx={{
            width: "320px",
            height: "300px",
            borderRadius: "20px",
            backgroundImage: `linear-gradient(to right, #7ABAF3, #8FBADFA3)`,
          }}
        >
          <CardContent>
            <VerifiedIcon
              sx={{
                marginLeft: "80%",
                color: "#1D2877",
                height: "60px",
                width: "20%",
              }}
            />
            <Typography
              gutterBottom
              sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
            >
              {t("Ethics")}
            </Typography>
            <Typography color="#577ABE" sx={{ fontSize: "20px" }}>
              {t("We provide certain guidelines for drivers to abide to..")}
            </Typography>
          </CardContent>
          <CardActions></CardActions>
        </Card>

        <Card
          sx={{
            width: "320px",
            height: "300px",
            borderRadius: "20px",
            backgroundImage: `linear-gradient(to right, #7ABAF3, #8FBADFA3)`,
          }}
        >
          <CardContent>
            <PlaceIcon
              sx={{
                marginLeft: "80%",
                color: "#1D2877",
                height: "60px",
                width: "20%",
              }}
            />
            <Typography
              sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
            >
              {t("Pluralism")}
            </Typography>
            <Typography color="#577ABE" sx={{ fontSize: "20px" }}>
              {t(
                "We supporting more than one city in the Syrian and Lebanese version."
              )}
            </Typography>
          </CardContent>
          <CardActions></CardActions>
        </Card>

        <Card
          sx={{
            width: "320px",
            height: "300px",
            borderRadius: "20px",
            backgroundImage: `linear-gradient(to right, #7ABAF3, #8FBADFA3)`,
          }}
        >
          <CardContent>
            <VerifiedUserIcon
              sx={{
                marginLeft: "80%",
                color: "#1D2877",
                height: "60px",
                width: "20%",
              }}
            />
            <Typography
              sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
            >
              {t("Privacy")}
            </Typography>
            <Typography color="#577ABE" sx={{ fontSize: "20px" }}>
              {t("Now you can easily pay online with My Rides")}
            </Typography>
          </CardContent>
          <CardActions></CardActions>
        </Card>

        <Card
          sx={{
            width: "320px",
            height: "300px",
            borderRadius: "20px",
            backgroundImage: `linear-gradient(to right, #7ABAF3, #8FBADFA3)`,
          }}
        >
          <CardContent>
            <CreditCardIcon
              sx={{
                marginLeft: "80%",
                color: "#1D2877",
                height: "60px",
                width: "20%",
              }}
            />
            <Typography
              sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
            >
              {t("Electronic payment")}
            </Typography>
            <Typography color="#577ABE" sx={{ fontSize: "20px" }}>
              {t(
                "We make sure to keep your information strictly confidential."
              )}
            </Typography>
          </CardContent>
          <CardActions></CardActions>
        </Card>
      </Box>
    </Container>
  );
}
